import { render, staticRenderFns } from "./AllCorporateAccountsTable.vue?vue&type=template&id=72c71a40&scoped=true&"
import script from "./AllCorporateAccountsTable.vue?vue&type=script&lang=js&"
export * from "./AllCorporateAccountsTable.vue?vue&type=script&lang=js&"
import style0 from "./AllCorporateAccountsTable.vue?vue&type=style&index=0&id=72c71a40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c71a40",
  null
  
)

export default component.exports